// src/v2/pages/Reports/ReportSTL.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useReportSTL } from '../../hooks/useReportSTL';
import { ReportSTLModule } from '../../components/modules/Reports/ReportSTL/ReportSTLModule';

const ReportSTL = ({ isHideSideMenu }) => {
  const reportHook = useReportSTL();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <ReportSTLModule reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default ReportSTL;